import { useState, useEffect } from 'react';
import type { ExportJob } from '@atlas/shared';
import { NewExportForm } from '../components/NewExportForm.js';
import { ExportsTable } from '../components/ExportsTable.js';
import { subscribeToAllExports } from '../lib/exports.js';

export function ExportsPage() {
  const [exports, setExports] = useState<Array<ExportJob & { id: string }>>([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState<string | null>(null);

  useEffect(() => {
    const unsubscribe = subscribeToAllExports(
      (list) => {
        setExports(list);
        setLoading(false);
        setLoadError(null);
      },
      (err) => {
        setLoadError(err.message);
        setLoading(false);
      },
    );
    return unsubscribe;
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-8 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-[#37352f] tracking-tight">
          Exports
        </h1>
        <p className="text-sm text-[#73726e] mt-1">
          Export a client's data by selecting their agency.
        </p>
      </div>

      <div className="max-w-md mb-10">
        <NewExportForm existingExports={exports} />
      </div>

      {loadError && (
        <p className="text-sm text-[#e03e3e] bg-[#fbe8e8] border border-[#f5c6c6] rounded px-3 py-2 mb-4">
          Could not load exports: {loadError}
        </p>
      )}

      {(loading || exports.length > 0) && (
        <ExportsTable exports={exports} loading={loading} />
      )}
    </div>
  );
}
